export const INGRESO_ROUTE = "/"
export const SELECCION_ROUTE = "/seleccion"